<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >

        <div :class="$style.top" :libraryId="libraryId">
            <div>

                <el-row >
                    <el-col :span="20"><div align="left" style="padding-top: 8px; color: cornflowerblue">
                        <span style="color: cornflowerblue; font-size: 14px">文件总数：{{database_info.all_num}}个（视频：{{database_info.video_num}}个，文档：
                            {{database_info.document_num}}个，图片：{{database_info.photo_num}}个，其他：{{database_info.other_num}}个）</span>

                    </div></el-col>
                    <el-col :span="4"><div align="right">
                        <el-button  @click.stop="uploadEditFile(0,null)" size="small" icon="el-icon-upload" type="primary">上传文件</el-button>
                    </div></el-col>
                </el-row>
            </div>
            <div style="margin-top: 20px">

                <el-table
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column
                            fixed
                            prop="file_name"
                            label="文件名"
                            sortable>
                    </el-table-column>
                    <el-table-column
                            prop="file_type_text"
                            label="文件类型"
                            width="110"
                            sortable>
                    </el-table-column>
                    <el-table-column
                            prop="file_size"
                            label="文件大小"
                            width="110"
                            sortable>
                        <template slot-scope="scope">
                            <span>{{getFileSize(scope.row.file_size)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="status_text"
                            label="状态"
                            width="80"
                            sortable>
                    </el-table-column>

                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="150">
                        <template slot-scope="scope">
                            <el-button @click="uploadEditFile(1,scope.row)" type="primary" size="mini">编辑</el-button>
                            <el-button @click="setStatus(scope.row)" v-show="scope.row.status === 'ACTIVE'" type="danger" size="mini">停用</el-button>
                            <el-button @click="setStatus(scope.row)" v-show="scope.row.status === 'INACTIVE'" type="success" size="mini">启用</el-button>
                            <!--<el-button @click="downloadFile(scope.row)" type="warning" size="mini">下载</el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
                <!--<Pagination :page="page" @changePage="changePageClick"></Pagination>-->
            </div>

            <el-dialog
                    :visible.sync="dialogVisible"
                    width="40%"
                    :show-close="false"
                    :before-close="handleClose"

                    style="vertical-align: center;: #FFF9F3">
                <div style="margin-top: -40px;">

                    <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                        <el-col :span="12">
                            <div style="color: #3998F7;font-weight: bold;padding-top: 8px;font-size: 16px">{{fileObj.file_title}}
                            </div>
                        </el-col>

                        <el-col :span="12">
                            <div align="right">
                                <el-button type="danger" size="small" @click.stop="handleClose">
                                    关闭
                                </el-button>
                                <el-button type="primary" size="small" @click.stop="submitFile">
                                    上传
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>


                    <div class="subjectList" style="margin-top: 20px;">

                        <el-form ref="form" label-width="100px">
                            <el-form-item label="文件名称">
                                <el-input v-model="fileName" placeholder="请输入文件名称"></el-input>
                            </el-form-item>


                            <el-form-item label="上传文件" class="a_upload_file">

                                <el-upload
                                        ref="uploadFile"
                                        class="upload-demo"
                                        :http-request="uploadFun"
                                        :auto-upload="false"
                                        action="https://api.retailstore365.com:15021/uploadfile"
                                        :on-preview="handlePreview"
                                        :on-change="handChange"
                                        :on-remove="handleRemove"
                                        :before-remove="beforeRemove"
                                        :on-success="handlePDFSuccess"
                                        :before-upload="beforePDFUpload"
                                        multiple
                                        :limit="1"
                                        :on-exceed="handleExceed"
                                        :file-list="fileObj.fileList">
                                    <el-button size="small" type="primary">选择文件</el-button>
                                    <div slot="tip" class="el-upload__tip">上传的文件大小不能超过200M。</div>
                                </el-upload>
                            </el-form-item>

                        </el-form>
                    </div>

                </div>

            </el-dialog>

        </div>

    </div>
</template>

<script>
    import Pagination from '../../../../components/pagination'
    import http from '../../../../APIService/http'

    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                id: '',
                database_info:{
                    'all_num': 0,
                    'video_num': 0,
                    'document_num': 0,
                    'photo_num': 0,
                    'other_num': 0
                },
                detabaseObj:{},
                dialogVisible:false,
                fileObj:{
                    file_title : '',
                    file_Name : '',
                    fileList : []
                },
                fileName:'',

                isEdit : false,
                removeFile : false,
                isUpload : false,

                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
            }
        },
        created() {

        },
        components: {
            Pagination
        },
        computed: {
            libraryId() {
                this.detabaseObj = this.$store.getters.getDatabase
                let library_id = this.detabaseObj.library_id
                if (library_id) {
                    this.init()
                }
                return library_id
            }
        },
        methods: {

            async init() {
                try {

                    this.loading = true

                    let data = {
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        library_id:this.detabaseObj.library_id,
                        catalog_id:this.detabaseObj.catalog_id
                    }
                    this.tableData = []

                    await http.post('/wapi/v1/getFileList', data).then(res => {

                        // this.page.total = res.data.total

                        this.tableData = res.data.result_array

                        this.database_info = res.data.database_info

                        this.loading = false


                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            async setStatus(row) {
                try {
                    this.loading = true

                    let status = 'ACTIVE'
                    if(row.status === 'ACTIVE'){
                        status = 'INACTIVE'
                    }

                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        library_id:row.library_id,
                        catalog_id:row.catalog_id,
                        file_id:row.file_id,
                        status:status
                    }

                    await http.post('/wapi/v1/setFileStatus', data).then(res => {

                        // this.page.total = res.data.total

                        let success  = res.success

                        if(success){

                            if(row.status === 'ACTIVE'){
                                row.status = 'INACTIVE'
                                row.status_text = '关闭'
                            }else {
                                row.status = 'ACTIVE'
                                row.status_text = '启用'
                            }

                        }

                        this.loading = false


                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            downloadFile(row) {
                try {
                    this.loading = true

                    let Body = {
                        credential:'58f09f86-694c-472d-bb63-64f9be093fd2',
                        file_ids:row.file_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        reference_obj: 'CLIENT',
                        reference_id:'com.repatmobile365.ios'
                    }

                    // let res = http.post('https://api.retailstore365.com:15021/downloadfiles', Body)


                    var config = {
                        headers: {'Content-Type': 'multipart/form-data; boundary====0xKhTmLbOuNdArY'}
                    };  //添加请求头
                    http.post('https://api.retailstore365.com:15021/downloadfiles', Body)//
                        .then(response => {

                            if (response.success) {

                                this.savaFileId(response.data)

                            }
                        })
                        .catch(({err}) => {

                        })


                    let success  = res.success

                    this.loading = false

                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            uploadEditFile(num , item){

                this.dialogVisible = true

                if (num === 0) {
                    this.isEdit = false
                    this.isUpload = false

                    this.fileObj.file_title = '上传文件'
                    this.fileName = ''

                    this.fileObj.fileList = []
                } else {
                    this.isEdit = true
                    this.removeFile = false
                    this.isUpload = true

                    this.fileObj = item

                    this.fileObj.file_title = '文件详情'
                    this.fileName = item.file_name

                    this.fileObj.fileList = [{
                        name:item.file_name
                    }]
                }
            },
            getFileSize(num){

                let size_text;
                size_text = (parseInt(num)/1024).toFixed(0)//kb
                if(size_text >= 1024){
                    size_text = (size_text/1024).toFixed(0)//mb

                    size_text = size_text + 'MB'
                }else {
                    size_text = size_text + 'KB'
                }

                return size_text;
            },
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }

                if (size) {
                    this.page.size = size
                }
                this.init()
            },
            handleRemove(file, fileList) {

                this.removeFile = true
                this.isUpload = false
            },
            handlePreview(file) {

            },
            handChange(file) {
                this.isUpload = true
            },
            handleExceed(files, fileList) {

                this.$message.warning(`当前已存在一个文件，请先删除该文件`);
                //`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {

                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            // pdf上传成功
            handlePDFSuccess(res, file) {

            },
            // pdf上传前的验证
            beforePDFUpload(file) {
                // const fileType = file.type

                const fileSize = file.size / 1024 / 1024 < 200 * 1.2

                if (!fileSize) {
                    this.error('上传的文件大小不能超过 200MB!')
                }

                return true
            },



            uploadFun(param){

                if(this.isEdit && !this.removeFile){//有编辑但并未更换文件

                    this.savaFileId(this.fileObj)

                }else {

                    var data = new FormData(); //创建form对象
                    data.append('file',param.file);
                    data.append('reference_obj','CLIENT');
                    data.append('reference_id','com.saasyun.android');
                    data.append('credential','58f09f86-694c-472d-bb63-64f9be093fd2');
                    data.append('username',this.$store.getters.getUser.username);
                    data.append('tenant_id',this.$store.getters.getUser.tenant_id);
                    data.append('user_id',this.$store.getters.getUser.user_id);
                    // data.append('category','USER');
                    // data.append('size','300');
                    data.append('bucket','retaium-file');
                    data.append('category','LIBRARY');


                    var config = {
                        headers:{'Content-Type':'multipart/form-data'}
                    };  //添加请求头
                    http.post(param.action,data,config)//
                        .then(response=>{

                            if(response.success){

                                //如果是编辑并换了文件

                                if(this.isEdit && this.removeFile){

                                    this.fileObj.old_file_id = this.fileObj.file_id

                                }
                                const nameArr = response.data.filename.split('.')
                                this.fileObj.extension = '.'+ nameArr[nameArr.length-1]

                                this.fileObj.file_id = response.data.s3filename
                                this.fileObj.file_type = response.data.filetype
                                this.fileObj.file_size = response.data.filesize

                                this.savaFileId(this.fileObj)

                            }
                        })
                        .catch(({err}) => {

                            this.loading = false
                        })

                }

            },
            async savaFileId(obj){
                let userObj = this.$store.getters.getUser
                let detabaseObj = this.$store.getters.getDatabase

                let data = {
                    tenant_id: userObj.tenant_id,
                    user_id: userObj.user_id,
                    library_id:detabaseObj.library_id,
                    catalog_id:detabaseObj.catalog_id,
                    old_file_id:obj.old_file_id,
                    file_id:obj.file_id,
                    file_name:this.fileName,
                    file_type:obj.file_type,
                    file_size:obj.file_size,
                    extension:obj.extension,
                    created_by:userObj.user_id,
                    isEdit: this.isEdit,
                    removeFile: this.removeFile
                }

                await http.post('/wapi/v1/savaFileId', data).then(res => {

                    let success  = res.success

                    if(success){
                        this.dialogVisible = false
                        this.fileObj.fileList = []

                        this.$message({ message: '上传成功!', type: 'success' });
                        this.init()
                    }

                    this.loading = false


                })
            },
            submitFile() {
                if(!this.fileName){
                    this.$message({ message: '请输入文件名称', type: 'error' });
                    return
                }
                if(!this.isUpload){
                    this.$message({ message: '请上传文件', type: 'error' });
                    return
                }

                this.loading = true

                if (this.isEdit && !this.removeFile) {//有编辑但并未更换文件

                    this.savaFileId(this.fileObj)

                } else{
                    this.$refs.uploadFile.submit()
                }
            },
            handleClose(done) {
                this.fileObj.fileList = []
                this.dialogVisible = false
//                this.$confirm('确认关闭？')
//                    .then(_ => {
                done();
//                    })
//                    .catch(_ => {});
            },
        }
    }
</script>
<style lang="scss" module>
    .container {
        .top {

        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/develop/components/database/index.vue